import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const StarCircle: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.27176 4.66897L9.12994 6.40151C9.14945 6.44549 9.18016 6.48358 9.21899 6.51199C9.25782 6.5404 9.30341 6.55814 9.35123 6.56343L11.2457 6.84409C11.3005 6.85115 11.3523 6.87366 11.3948 6.909C11.4373 6.94434 11.4689 6.99106 11.4859 7.0437C11.5029 7.09633 11.5046 7.15271 11.4907 7.20624C11.4768 7.25979 11.448 7.30827 11.4076 7.34605L10.0421 8.70078C10.0072 8.73334 9.98106 8.7741 9.966 8.81934C9.95094 8.86459 9.94738 8.91289 9.95575 8.95985L10.285 10.8651C10.2945 10.9198 10.2885 10.9762 10.2676 11.0277C10.2467 11.0792 10.2117 11.1237 10.1668 11.1563C10.1218 11.189 10.0685 11.2083 10.0131 11.2122C9.95763 11.216 9.90226 11.2042 9.8532 11.1781L8.14762 10.2768C8.10395 10.2554 8.05594 10.2442 8.00729 10.2442C7.95864 10.2442 7.91064 10.2554 7.86696 10.2768L6.16141 11.1781C6.11234 11.2042 6.05694 11.216 6.0015 11.2122C5.94606 11.2083 5.89282 11.189 5.84783 11.1563C5.80284 11.1237 5.76791 11.0792 5.74701 11.0277C5.72611 10.9762 5.72009 10.9198 5.72962 10.8651L6.05886 8.93826C6.0672 8.8913 6.06367 8.843 6.04859 8.79775C6.03351 8.75251 6.00735 8.71175 5.9725 8.67919L4.59078 7.34605C4.54991 7.30724 4.52116 7.25741 4.50802 7.2026C4.49489 7.14778 4.49793 7.09033 4.51678 7.03721C4.53563 6.98409 4.56948 6.93758 4.61423 6.9033C4.65897 6.86902 4.7127 6.84846 4.7689 6.84409L6.66336 6.56343C6.71118 6.55814 6.75677 6.5404 6.7956 6.51199C6.83443 6.48358 6.86513 6.44549 6.88465 6.40151L7.74282 4.66897C7.76619 4.61851 7.80351 4.57579 7.85038 4.54585C7.89724 4.51591 7.95168 4.5 8.00729 4.5C8.0629 4.5 8.11735 4.51591 8.16422 4.54585C8.21107 4.57579 8.24839 4.61851 8.27176 4.66897Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
